import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/user';
import { Router } from '@angular/router';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { PushNotificationService } from 'src/app/modules/userModule/shared/push-notification.service';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  user: User = new User();
  userNameCheck = true;
  passwordCheck = true;
  userNameErrorMessage = "Check";
  response: any;
  userNameValid = true;
  message: string = "Generating your access token...";
  constructor(private userhttpService: UserService, private router: Router,
    private _notificationService: PushNotificationService, private httpService: HttpService) {
    this._notificationService.requestPermission();
  }

  ngOnInit() {
    let user = JSON.parse(sessionStorage.getItem("userinfo")) as User;
    this.httpService.getBasePath().then(base => {
      setTimeout(() => {
        this.login();
      }, 100)
    });

    if (user && user.termsAndConditions === "Y" && user.termsAndConditions.length > 0) {
      this.router.navigateByUrl("/val-assets/home");
    }
  }

  login() {
    if (!this.user.userEmailId || this.user.userEmailId.length === 0) {
      this.userNameCheck = false;
    } else {
      this.userNameCheck = true;
    }
    if (this.userNameCheck && !this.user.userEmailId.endsWith('@siemens-healthineers.com')) {
      this.userNameValid = false;
    } else {
      this.userNameValid = true;
    }
    // call the service to login

    this.userhttpService.loginUser().subscribe(
      data => {
        this.passwordCheck = true;
        this.userNameCheck = true;
        this.response = data;
        console.log(this.response);
        this.userhttpService.loggendInUser = this.response.userDetails as User;
        this.userhttpService.loggendInUser.showActiveUsersInfo = this.response.showActiveUsersInfo;
        // console.log("Hi");
        console.log(this.userhttpService.loggendInUser)
        if ('Y' !== this.userhttpService.loggendInUser.termsAndConditions) {
          document.getElementById('termsModal').setAttribute('visible', 'true');
        } 
        else {
          sessionStorage.setItem("userinfo", JSON.stringify(this.userhttpService.loggendInUser));
          if (this.response.notifications && this.response.notifications.length > 0) {
            let notificationData: Array<any> = [];
            let notifications = this.response.notifications.filter(n => !n.viewedNotification);
            for (let n of notifications) {
              notificationData.push({
                'title': 'Val Asset',
                'url': `http://val.hccloud.siemens.com/#/val-assets/search/${n.assetId}`,
                'serverUrl': `${this.httpService.basePath}/user/markNotificationAsRead/${n._id}`,
                'alertContent': n.notificationMsg
              });
            }
            this._notificationService.generateNotification(notificationData);
          }
        }
        this.httpService.getEncryptedPassphrase().then(pass => {
          if (pass != null)
            this.getAccessToken(pass);
          else
            this.message = "Error fetching credentials";
        }, err => {
          console.log("error");
        });
      },
      error => {
        console.log(error);
      },

      ()=>{
        
      });
  }

  declineTerms() {
    document.getElementById('termsModal').removeAttribute('visible');
  }

  acceptTerms() {
    this.userhttpService.loggendInUser.termsAndConditions = "Y";
    sessionStorage.setItem("userinfo", JSON.stringify(this.userhttpService.loggendInUser));
    this.userhttpService.termsAndConditions(this.userhttpService.loggendInUser.userEmailId).subscribe(
      data => {
        if (null !== data) {
          this.router.navigateByUrl('/val-assets/home');
        }
      }
    )
  }

  getAccessToken(encr) {
    let tokenRequest = { EncryptedPassPhrase: encr.encryptedPassphraseVAL, ApplicationId: encr.applicationId };
    this.httpService.getAccessToken(tokenRequest, this.userhttpService.loggendInUser.userEmailId).subscribe(res => {
      sessionStorage.setItem("authentication", res["token"]); //save in session storage. fetch when needed
      if(this.userhttpService.loggendInUser.termsAndConditions === 'Y')
        this.router.navigateByUrl("/val-assets/home");
    }, err => {
      console.log(err);
    });
  }

}
